export default __webpack_public_path__ + "static/media/bagfactory.b7a781ce.png";